import type {
  AnchorHTMLAttributes,
  ReactNode
} from 'react';

import
  Link
from 'next/link';

import {
  OUTLINE_BUTTON_CLASSES
} from '@repo/brand';

interface OutlineButtonProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string
  children: ReactNode
  // Plain <a> instead of next/link's <Link> - for external hrefs, matching
  // PrimaryButton/SecondaryButton's identical reasoning.
  external?: boolean
  // Full-width block layout - default is an inline pill, matching
  // PrimaryButton/SecondaryButton's convention.
  block?: boolean
}

// Neutral bordered pill - for a CTA that needs the pill shape without
// competing with a page's brand-colored primary/secondary action (e.g.
// "Back", "View all", "Dashboard home"). See OUTLINE_BUTTON_CLASSES
// (packages/brand) for why this exists as a shared component.
export default function OutlineButton({
  href, children, className, external, block, ...props
}: OutlineButtonProps) {

  const layout = block ? 'block' : 'inline-flex items-center justify-center';

  const mergedClassName = className
    ? `${ layout } ${ OUTLINE_BUTTON_CLASSES } ${ className }`
    : `${ layout } ${ OUTLINE_BUTTON_CLASSES }`;

  if (external) {

    return (
      <a
        href={href}
        className={mergedClassName}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      href={href}
      className={mergedClassName}
      {...props}
    >
      {children}
    </Link>
  );
}
